import React from "react";
import Hero from "../../components/Home/Hero";

const Home = () => {
  return (
    <section id="home" data-scroll-section className="overflow-x-hidden">
      <Hero />
    </section>
  );
};

export default Home;
